import React from 'react';

import type { PendingHumanCall } from '../types';
import type { PopoverContentProps, TabTypeHandler } from './types';

/**
 * The human call a case is waiting on, before anyone has dialled (BV-1575).
 *
 * UI-only: there is no call object behind this pill, so it carries no id to copy, no
 * status, and no timestamps. It exists so the attempts strip is not empty during the
 * pre-call phase — selecting it lands on the Call Script layout, where the script reads
 * the CASE's output. The moment a call is created the real attempt takes its place (the
 * strip drops this item and auto-selects the new call), and the pill fills in with actual
 * values.
 */
const PendingHumanCallPopoverContent: React.FC<PopoverContentProps<PendingHumanCall>> = () => (
  <div className="space-y-2 text-sm">
    <div className="flex justify-between gap-8">
      <span className="text-muted-foreground">Type:</span>
      <span>Human Call</span>
    </div>
    <div className="flex justify-between gap-8">
      <span className="text-muted-foreground">Status:</span>
      <span>Not dialled yet</span>
    </div>
    <p className="max-w-[16rem] text-xs text-muted-foreground">
      The call script is ready — details appear here once the call starts.
    </p>
  </div>
);

export const pendingHumanCallHandler: TabTypeHandler<PendingHumanCall> = {
  isDisabled: false,
  getLabel: () => 'Human Call Preview',
  getStatusLabel: () => 'Preview',
  PopoverContent: PendingHumanCallPopoverContent,
};
